// Formatadores BR. Toda formatação de display passa por aqui.

export function formatCPF(raw: string): string {
  const d = raw.replace(/\D/g, '').slice(0, 11);
  if (d.length !== 11) return raw;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9, 11)}`;
}

export function formatCNPJ(raw: string): string {
  const d = raw.replace(/\D/g, '').slice(0, 14);
  if (d.length !== 14) return raw;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12, 14)}`;
}

export function formatPhone(raw: string): string {
  const d = raw.replace(/\D/g, '');
  if (d.length === 11) return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return raw;
}

export function formatDateBR(iso: string | Date): string {
  // Datas puras (YYYY-MM-DD ou YYYY-MM-DDT00:00:00Z) precisam de timeZone UTC
  // pra não shiftar um dia em fuso BR (UTC-3). Postgres date columns chegam assim.
  if (typeof iso === 'string') {
    const m = iso.match(/^(\d{4}-\d{2}-\d{2})(?:T00:00:00(?:\.000)?Z?)?$/);
    if (m) {
      const d = new Date(m[1] + 'T00:00:00Z');
      return d.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
    }
  }
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  return d.toLocaleDateString('pt-BR');
}

export function formatDateTimeBR(iso: string | Date): string {
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  return d.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
}

export function formatRelative(iso: string | Date): string {
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  const diff = Date.now() - d.getTime();
  const min = Math.floor(diff / 60_000);
  if (min < 1) return 'agora';
  if (min < 60) return `${min} min atrás`;
  const hours = Math.floor(min / 60);
  if (hours < 24) return `${hours}h atrás`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d atrás`;
  return formatDateBR(d);
}

export function formatBRL(value: number): string {
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

// Title Case PT-BR — primeira letra maiúscula, resto minúsculo, partículas
// (da, de, do, e, em…) ficam minúsculas em meio de frase. Defensivo: dados
// no banco vieram com casing inconsistente (CAIXA ALTA, AndréA, etc.).
const _NAME_LOWER = new Set([
  'da','de','do','das','dos','di','du','e','é','em','na','no','nas','nos',
  'a','o','as','os','ao','aos','à','às','com','por','para','sob','sobre','sem','até',
]);
export function formatName(name: unknown): string {
  if (name == null || name === '') return '';
  const words = String(name).trim().split(/\s+/);
  return words
    .map((w, i) => {
      if (!w) return w;
      const lower = w.toLowerCase();
      if (i > 0 && _NAME_LOWER.has(lower)) return lower;
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(' ');
}
